import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import $ from "jquery";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";

const icon1 = require("./../assets/img/dashboard-icon.svg").default;
const icon2 = require("./../assets/img/info-icon.svg").default;
const icon3 = require("./../assets/img/app-icon.svg").default;
const icon4 = require("./../assets/img/payment-icon.svg").default;
const icon5 = require("./../assets/img/store-icon.svg").default;
const icon6 = require("./../assets/img/list-icon.svg").default;
const icon7 = require("./../assets/img/order-icon.svg").default;
const icon8 = require("./../assets/img/plan-icon.svg").default;
const icon9 = require("./../assets/img/logout-icon.svg").default;
const deleteIcon = require("./../assets/img/delete-icon.svg").default;

const Sidebar = (props) => {
  const navigate = useNavigate();
  const { langJson } = useLanguage();
  const { user, setUser, sidebarOpenContext, setSidebarOpenContext } = useAuth();
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [storedUserData, setStoredUserData] = useState();

  const onLogout = () => {
    localStorage.removeItem("FFFUserData");
    navigate("/");
    setUser(null);
  };

  useEffect(() => {
    $(".mobileBtn").click(() => {
      $(".sideBar").toggleClass("active");
    });
    const storedUserData = JSON.parse(localStorage.getItem("FFFUserData"));
    setStoredUserData(storedUserData);
  }, []);

  useEffect(() => {
    if (sidebarOpenContext) {
      $(".sidedBar").addClass("mobileOpen");
      $("body").addClass("bodyNoScroll");
    } else {
      $(".sidedBar").removeClass("mobileOpen");
      $("body").removeClass("bodyNoScroll");
    }
  }, [sidebarOpenContext]);

  return (
    <>
      {user?.role == "admin" ? (
        <div className="sidedBar">
          <button className="sidebarCloseBtn" onClick={() => setSidebarOpenContext(!sidebarOpenContext)} role="button" tabIndex={0}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#ffffff">
              <path d="M0 0h24v24H0z" fill="none" />
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
          <ul>
            <li>
              <Link to="/admin-dashboard" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon1} alt="" />
                {langJson?.dashboard}
              </Link>
            </li>
            <li>
              <Link to="/admin/pages/about-us?lang=en" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon2} alt="" />
                {langJson?.aboutus}
              </Link>
            </li>
            <li>
              <Link to="/admin/pages/privacy-policy?lang=en" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon2} alt="" />
                {langJson?.privacypolicy}
              </Link>
            </li>
            <li>
              <Link to="/admin/pages/imprint?lang=en" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon2} alt="" />
                {langJson?.imprint}
              </Link>
            </li>
            <li>
              <Link to="/admin/pages/support?lang=en" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon2} alt="" />
                {langJson?.support}
              </Link>
            </li>
            <li>
              <Link to="/admin/pages/terms-of-use?lang=en" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon2} alt="" />
                {langJson?.termofuse}
              </Link>
            </li>
            <li>
              <Link to="/website-info" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon2} alt="" />
                {langJson?.websiteinformation}
              </Link>
            </li>
            <li>
              <Link to="/admin/events" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon8} alt="" />
                {langJson?.events}
              </Link>
            </li>
	    <li>
              <Link to="/admin/categories" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon2} alt="" />
                Categories
              </Link>
            </li>
            <li>
              <Link to="/admin/videos" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon8} alt="" />
                {langJson?.videos}
              </Link>
            </li>
            <li>
              <Link to="/admin/blogs" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon8} alt="" />
                {langJson?.blogs ?? 'Blogs'}
              </Link>
            </li>
            <li>
              <Link to="/admin/announcements" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon3} alt="" />
                {langJson?.announcements ?? 'Announcements'}
              </Link>
            </li>
            <li>
              <Link to="/admin/contact-forms" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon6} alt="" />
                {langJson?.contactforms ?? 'Contact Forms'}
              </Link>
            </li>
            <li>
              <Link to="/admin/stores" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon5} alt="" />
                {langJson?.stores ?? 'Stores'}
              </Link>
            </li>
            <li>
              <a href="javascript:void(0);" onClick={() => onLogout()}>
                <img src={icon9} alt="" />
                {langJson?.logout}
              </a>
            </li>
          </ul>
        </div>
      ) : (
        <div className="sidedBar">
          <button className="sidebarCloseBtn" onClick={() => setSidebarOpenContext(!sidebarOpenContext)} role="button" tabIndex={0}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#ffffff">
              <path d="M0 0h24v24H0z" fill="none" />
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
          <ul>
            <li>
              <Link to="/dashboard" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon1} alt="" />
                {langJson?.dashboard}
              </Link>
            </li>
            <li>
              <Link to="/company-info" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon2} alt="" />
                {langJson?.companyinformation}
              </Link>
            </li>
            <li>
              <Link to="/vendor-change-password" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon2} alt="" />
                {langJson?.changepassword}
              </Link>
            </li>
            <li>
              <Link to="/choose-category" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon3} alt="" />
                {langJson?.choosecategory}
              </Link>
            </li>
            <li>
              <Link to="/requests" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon7} alt="" />
                {langJson?.requests}
              </Link>
            </li>
            <li>
              <Link to="/choose-payment" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon4} alt="" />
                {langJson?.choosepayment}
              </Link>
            </li>
            <li>
              <Link to="/customize-store" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon5} alt="" />
                {langJson?.customizeyourstore}
              </Link>
            </li>
            {/* <li>
              <Link to="/imprint-privacy-policy">
                <img src={icon2} alt="" />
                {langJson?.imprintprivacypolicy}
              </Link>
            </li> */}
            <li>
              <Link to="/products" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon6} alt="" />
                {langJson?.products}
              </Link>
            </li>
            <li>
              <Link to="/orders" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon7} alt="" />
                {langJson?.orders}
              </Link>
            </li>
            <li>
              <Link to="/plans-and-pricing" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon8} alt="" />
                {langJson?.upgradeplan}
              </Link>
            </li>
            <li>
              <Link to="/vendor-events" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon8} alt="" />
                {langJson?.events}
              </Link>
            </li>
            <li>
              <Link to="/vendor-videos" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon8} alt="" />
                {langJson?.videos}
              </Link>
            </li>
            <li>
              <Link to="/contact-forms" onClick={() => setSidebarOpenContext(false)}>
                <img src={icon6} alt="" />
                {langJson?.contactforms ?? 'Contact Forms'}
              </Link>
            </li>
            <li>
              <a href="javascript:void(0);" onClick={() => onLogout()}>
                <img src={icon9} alt="" />
                {langJson?.logout}
              </a>
            </li>
            <li className="menuSpacer" aria-hidden="true"></li>
          </ul>
        </div>
      )}
    </>
  );
};

export default Sidebar;
